import { prettyStatus } from "../utils/labels";

const colorMap: Record<string, string> = {
  draft: "bg-grove-100 text-bark-500 border-grove-300",
  active: "bg-forest-50 text-forest-700 border-forest-200",
  under_loi: "bg-honey-50 text-honey-700 border-honey-200",
  under_contract: "bg-blue-50 text-blue-700 border-blue-200",
  closed: "bg-bark-100 text-bark-500 border-bark-200",
  dead: "bg-red-50 text-red-600 border-red-200",
  archived: "bg-honey-50 text-honey-700 border-honey-200",
  pending: "bg-grove-100 text-bark-500 border-grove-300",
  processing: "bg-blue-50 text-blue-700 border-blue-200",
  complete: "bg-forest-50 text-forest-700 border-forest-200",
  needs_review: "bg-honey-50 text-honey-700 border-honey-200",
  error: "bg-red-50 text-red-700 border-red-200",
};

export default function StatusBadge({ status }: { status: string }) {
  const color = colorMap[status] || "bg-grove-100 text-bark-500 border-grove-300";
  const label = prettyStatus(status);
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md border text-[11px] font-semibold uppercase tracking-wider ${color}`}
    >
      {label}
    </span>
  );
}
